import React from 'react';

type EditProps = {
  title?: string;
};

const Edit = ({ title = undefined }: EditProps): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {title && <title data-testid="icon-edit">{title}</title>}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5391 7.686L17.2731 8.951L15.0471 6.724L16.3111 5.458C16.9241 4.847 17.9231 4.844 18.5391 5.458C19.1521 6.073 19.1521 7.072 18.5391 7.686ZM7.95911 18.264L5.24111 18.756L5.73311 16.039L13.6331 8.138L15.8591 10.365L7.95911 18.264ZM19.9531 4.044C18.5581 2.651 16.2911 2.653 14.8971 4.044L4.09811 14.845C3.95311 14.989 3.85711 15.173 3.82011 15.374L3.01611 19.82C2.95811 20.142 3.06111 20.473 3.29311 20.705C3.48211 20.894 3.73711 20.998 4.00011 20.998C4.06011 20.998 4.11911 20.993 4.17811 20.982L8.62311 20.177C8.82411 20.14 9.00911 20.044 9.15211 19.9L19.9531 9.1C21.3461 7.707 21.3461 5.438 19.9531 4.044Z"
    />
  </svg>
);

export default Edit;
